import React, { useEffect } from 'react';
import TermsOfUse from '../components/Pages/TermsOfUse/TermsOfUse';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer/Footer';
import FloatingBackground from '../components/Common/FloatingBackground/FloatingBackground';
import { useScrollState } from '../stores/scrollStore';

const TermsPage: React.FC = () => {
  const { isScrolled, scrollProgress, throttledUpdateScrollState } = useScrollState();

  useEffect(() => {
    // Use throttled scroll handler for native scrolling
    const handleScroll = () => {
      throttledUpdateScrollState(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [throttledUpdateScrollState]);

  return (
    <>
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      <div>
        <div className="legal-page-container" style={{ position: 'relative', zIndex: 1 }}>
          <FloatingBackground />
          <TermsOfUse />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsPage;
